import type { EligibleRewardRequestBodySchema } from "@jti/evo-client";
import type { CampaignOrderData } from "@jti/rest-api-types";

type EligibleRewardItem = {
  price: number;
  qty: number;
  categories?: number[];
};

export const convertCampaignOrderToEligibleRewardRequest = (
  order: CampaignOrderData
): EligibleRewardRequestBodySchema => {
  const items: Record<string, EligibleRewardItem> = {};

  Object.entries(order.items ?? {}).forEach(([sku, item]) => {
    if (!item) {
      return;
    }

    const price = item.price ?? 0;
    const qty = item.qty ?? 0;

    let categories: number[] | undefined;

    if (item.categories?.length) {
      const numericCategories = item.categories
        .map((category) => Number(category))
        .filter((value) => !Number.isNaN(value));

      if (numericCategories.length) {
        categories = numericCategories;
      }
    }

    items[sku] = {
      price,
      qty,
      ...(categories && { categories }),
    };
  });

  return {
    order: {
      order_total: order.orderTotal,
      ...(order.minimumPayableAmount !== undefined && {
        minimum_payable_amount: order.minimumPayableAmount,
      }),
      items,
    },
  };
};
